import { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import { API, getAuthToken } from "@/App";

// Active Pickup Warehouses from Warehouse Master; refreshed on window focus and on demand.
export function useActiveWarehouses() {
  const [warehouses, setWarehouses] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/warehouses`, { headers: { Authorization: `Bearer ${getAuthToken()}` } });
      const seen = new Set();
      setWarehouses((res.data || []).filter((w) => w.is_active && !seen.has(w.id) && seen.add(w.id)));
      setLoaded(true);
    } catch {
      /* keep the last known list */
    }
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [refresh]);

  const options = useMemo(
    () => warehouses.map((w) => ({
      value: w.id,
      label: `${w.warehouse_name} (${w.warehouse_code})`,
      subtitle: w.warehouse_type === "weekly_allocation" ? "Weekly Allocation" : "FBW Inventory",
      searchTerms: [w.warehouse_name, w.warehouse_code],
    })),
    [warehouses]
  );

  const isActive = useCallback((id) => warehouses.some((w) => w.id === id), [warehouses]);

  return { warehouses, options, loaded, refresh, isActive };
}
